import {ProbabilityBench, TvNetwork, UnitStatusType} from "modules/enums";
import {createAction} from "redux-act";

export const getUnitsJson = createAction();

export interface ILineup {
	playerId: number;
	lineupNumber: number | null;
	bench: number | null;
	starter: number | null;
	type: ProbabilityBench | null;
}

interface IUnit {
	id: number;
	feedId: number;
	roundId: number;
	startDateTime: Date;
	lockDateTime: Date;
	homeSquadId: number;
	awaySquadId: number;
	homeProbablePitcherId: number | null;
	awayProbablePitcherId: number | null;
	status: UnitStatusType;
	tvNetwork: TvNetwork | null;
	tvNetworkLink: null;
	lineups: ILineup[];
	isFree: boolean;
}

export const getUnitsJsonSuccess = createAction<IUnit[]>();
export const getUnitsJsonFailed = createAction();

export const getHistoryUnitsJson = createAction();

export const getHistoryUnitsJsonSuccess = createAction<IUnit[]>();
export const getHistoryUnitsJsonFailed = createAction();
